﻿//Från Search.cshtml
export function initSearch() {

    function filter(Element) {
        let submitoOK = false;
        if (Element.name == "pf" || Element.name == "pt") {
            ///Pubkontroll
            let valfrom = $("#pubfran").children("option:selected").val();
            let valto = $("#pubtill").children("option:selected").val();

            if (valfrom != "0" && valto != "0") {
                if (valto >= valfrom) {
                    submitoOK = true;
                }
                else {
                    alert("Felaktig sökning på publiceringsår");
                }
            }
            else {
                submitoOK = true;
            }
        }
        else {
            submitoOK = true;
        }
        if (submitoOK)
            document.forms[0].submit();
    }

    const search = document.getElementById("searchQuery");

    if (search) {
        search.addEventListener("search", function (event) {            
            if ($("#searchQuery").val() == "") {
                Rensa("f-searchQuery")
            }
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        const search = document.getElementById("searchQuery");

        if (search) {
            search.focus();
        }
    });

    const titel = document.getElementById("titel");

    if (titel) {
        titel.addEventListener("search", function () {
            if ($("#titel").val() == "") {
                Rensa("tt-titel");
            }
        });
    }

    const forfattare = document.getElementById("forfattare");

    if (forfattare) {
        document.getElementById("forfattare").addEventListener("search", function (event) {
            if ($("#forfattare").val() == "") {
                Rensa("ff-forfattare")
            }
        });
    }

    $("#ResultSort").change(function () {
        document.forms[0].submit();
    });
    $("#ResultCount").change(function () {
        document.forms[0].submit();
    });
    $("#serie").change(function () {
        filter(this);
    });
    $("#utgivare").change(function () {
        filter(this);
    });
    $("#pubfran").change(function () {
        filter(this);
    });
    $("#pubtill").change(function () {
        filter(this);
    });

    function Rensa(id) {
        let clearId = ''

        //Fritext
        if (id.substring(0, 2) == "f-") {
            clearId = '#' + id.substring(2);
            $(clearId).val('');
        }

        id = id.toLowerCase();
        //Hylla
        if (id.substring(0, 2) == "h-") {
            clearId = '#' + id.substring(2);
            $(clearId).val('');
            $('#hyllsokId').val('');
        }
        //Serie
        if (id.substring(0, 2) == "s-") {
            $("#serie")[0].selectedIndex = 0;
        }
        //Utgivare
        if (id.substring(0, 2) == "u-") {
            $("#utgivare")[0].selectedIndex = 0;
        }
        //Publicerat från
        if (id.substring(0, 3) == "pf-") {
            $("#pubfran")[0].selectedIndex = 0;
            $("#pubtill")[0].selectedIndex = 0;
        }
        if (id.substring(0, 2) == "m-") {
            let mediaArray = id.substring(2).split(',');
            for (let i = 0; i < mediaArray.length; i++) {
                mediaArray[i] = mediaArray[i].replace("[", "");
                mediaArray[i] = mediaArray[i].replace("]", "");
                clearId = '#Media-' + mediaArray[i];
                $(clearId).prop("checked", false);
            }
        }

        if (id.substring(0, 3) == "tt-") {
            clearId = '#' + id.substring(3);
            $(clearId).val('');
        }
        if (id.substring(0, 3) == "ff-") {
            clearId = '#' + id.substring(3);
            $(clearId).val('');
        }
        if (id == "extern") {
            clearId = '#externsok';
            $(clearId).val('');
        }


        document.forms[0].submit();
    }

    function searchSmallConditionsToggle() {
        document.getElementById("SearchQueryPadding").classList.toggle("hide-for-smallview");
    }

    $('li.toggleItem').on('click', function () {
        window.location.href = $(this).children('a').attr("href");
        return false;
    });

    $('#searchSmallArea').on('click', function () {
        searchSmallConditionsToggle();
    });

    $(document).ready(function () {
        // Klick på knappen (hanterar både <i> och knapparea på mobil)
        $('button.ds-c-interactive-tag').on('click', function (e) {
            e.stopPropagation();

            var icon = $(this).find('i.removesymbol');
            if (icon.length > 0) {
                var id = icon.attr('id');
                Rensa(id);
            }
        });
    });


    $('.mediabox').on('change', function () {
        filter($(this));
    });

    document.querySelector('.skip-link')?.addEventListener('click', function () {
        const target = document.getElementById('search-results');

        if (target) {
            target.focus();
        }
    });
}
